import React, { useContext, useEffect, useState } from "react";
import "./personalinfo.css";
import ProfileHeader from "../components/ProfileHeader";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ProfileContext } from "../../../context/ProfileContext";
import { ReferralPartnerUpdateAPI } from "../../../api/ReferralPartnerAPI";
import Swal from "sweetalert2";
import {  WCPartnerHandle } from "../../../firebase/FileHandler";


const BankDetails = () => {
  const [isEdit, setIsEdit] = useState(false);
  const { openSidebar } = useOutletContext();
  const { user, setUser } = useContext(ProfileContext);
  const [isSaving, setIsSaving] = useState(false);
  const [previewImage, setPreviewImage] = useState(null)
  const navigate = useNavigate();

  const isReferralPartner = user?.type === "referralPartner";
const [profile, setProfile] = useState({
  accountNumber: "",
  ifsc: "",
  bankName: "",
});

const [fullName, setFullName] = useState("");
const [cancelledCheque, setCancelledCheque] = useState(null);

// Load user data once when the component mounts or when user changes
useEffect(() => {
  if (!user) return;

  const bankData = isReferralPartner ? user.banking || {} : user.bankDetails || {};

  setProfile({
    accountNumber: bankData.accountNumber || "",
    ifsc: bankData.ifsc || "",
    bankName: bankData.bankName || "",
  });

  setFullName(user.fullName || "");

  if (!isReferralPartner) {
    setCancelledCheque(bankData.cancelledChequeURL || null);
  } else {
    setCancelledCheque(null); // referral partners don't have cancelled cheque
  }
}, [user, isReferralPartner]); // single effect only

// Clean up preview image object URLs
useEffect(() => {
  return () => {
    if (previewImage && previewImage.startsWith("blob:")) {
      URL.revokeObjectURL(previewImage);
    }
  };
}, [previewImage]);

// Handle changes in input fields
const handleChange = (e) => {
  const { name, value } = e.target;

  setProfile((prev) => ({
    ...prev,
    [name]: name === "ifsc" ? value.toUpperCase() : value,
  }));
};

// Handle selecting a new cancelled cheque file
const handleChequeSelect = (e) => {
  if (e.target.files?.[0]) {
    setCancelledCheque(e.target.files[0]); // store File object
  }
};

// Toggle edit mode
const handleEditToggle = () => {
  if (isEdit) {
    // Cancel → reset profile and cheque to original user data
    const bankData = isReferralPartner ? user.banking || {} : user.bankDetails || {};
    setProfile({
      accountNumber: bankData.accountNumber || "",
      ifsc: bankData.ifsc || "",
      bankName: bankData.bankName || "",
    });
    if (!isReferralPartner) {
      setCancelledCheque(bankData.cancelledChequeURL || null);
    } else {
      setCancelledCheque(null);
    }
  }
  setIsEdit(!isEdit);
};

  // const handleUpdate = async () => {
  //   if (!user?._id) return;
  //   setIsSaving(true);

  //   try {
  //     const payload = {
  //       banking: { ...profile },
  //     };

  //     const res = await ReferralPartnerUpdateAPI(user._id, payload);

  //     if (res?.success) {
  //       // ✅ update context (auto localStorage sync)
  //       setUser((prev) => ({
  //         ...prev,
  //         banking: profile,
  //       }));

  //       setIsEdit(false);

  //       Swal.fire({
  //         icon: "success",
  //         title: "Bank Details Updated",
  //         text: "Your bank details have been successfully updated!",
  //       });
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops!",
  //         text: res?.message || "Something went wrong. Please try again.",
  //       });
  //     }
  //   } catch (error) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops!",
  //       text: error?.message || "Something went wrong. Please try again.",
  //     });
  //   } finally {
  //     setIsSaving(false);
  //   }
  // };

const handleUpdate = async () => {
  if (!user?._id) return;
  setIsSaving(true);

  try {
   let updatedBanking = { ...profile, fullName };

    if (!isReferralPartner && cancelledCheque instanceof File) {
      const res = await WCPartnerHandle(cancelledCheque, "cancelled-cheque", fullName);
      if (res?.success) updatedBanking.cancelledChequeURL = res.downloadURL;
    } else if (!isReferralPartner) {
      updatedBanking.cancelledChequeURL = cancelledCheque; // existing URL
    }

    const payload = isReferralPartner
      ? { banking: updatedBanking }
      : { bankDetails: updatedBanking };

    const res = await ReferralPartnerUpdateAPI(user._id, payload,isReferralPartner);

    if (res?.success) {
      setUser((prev) =>
        isReferralPartner
          ? { ...prev, banking: updatedBanking }
          : { ...prev, bankDetails: updatedBanking }
      );
      setIsEdit(false);
      Swal.fire({
        icon: "success",
        title: "Bank Details Updated",
        text: "Your bank details have been successfully updated!",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: res?.message || "Something went wrong. Please try again.",
      });
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops!",
      text: error?.message || "Something went wrong. Please try again.",
    });
  } finally {
    setIsSaving(false);
  }
};

  return (
    <div className="rp-personalinfo-page">
      <ProfileHeader onMenuClick={openSidebar} val="Bank Details" />

      <div className="rp-personalinfo-card">
        <div className="rp-personalinfo-header">
          <button
            className="rp-personalinfo-back-btn"
            onClick={() => navigate("/profile")}
          >
            <ArrowLeft size={14} /> Back
          </button>

          <button
            className="rp-personalinfo-edit-btn"
            onClick={handleEditToggle}
          >
            {isEdit ? "Cancel" : "Edit"}
          </button>
        </div>

        <div className="rp-personalinfo-grid">
<div className="rp-personalinfo-field">
  <label className="rp-personalinfo-label">Full Name</label>
  <input
    type="text"
    name="fullName"
    value={fullName}
    className="rp-personalinfo-input"
    disabled // always readonly
  />
</div>

{Object.keys(profile).map((key) => (
  <div className="rp-personalinfo-field" key={key}>
    <label className="rp-personalinfo-label">
      {key.replace(/([A-Z])/g, " $1")}
    </label>
    <input
      className="rp-personalinfo-input"
      type="text"
      name={key}
      value={profile[key]}
      onChange={handleChange}
      disabled={!isEdit}
    />
  </div>
))}
        </div>
{!isReferralPartner && (
        <div className="rp-personalinfo-compliance-item">
  <label className="rp-personalinfo-label">Cancelled Cheque</label>
  
  {cancelledCheque ? (
    <div className="rp-personalinfo-file-card">
      <img
        src={
          cancelledCheque instanceof File
            ? URL.createObjectURL(cancelledCheque)
            : cancelledCheque
        }
        className="rp-personalinfo-thumb"
        alt="Cancelled Cheque"
      />
      <div className="rp-personalinfo-file-actions">
        <button
          className="rp-personalinfo-view-btn"
          onClick={() =>
            setPreviewImage(
              cancelledCheque instanceof File
                ? URL.createObjectURL(cancelledCheque)
                : cancelledCheque
            )
          }
        >
          View
        </button>
        {isEdit && (
          <label className="rp-personalinfo-change-btn">
            Edit
            <input type="file" hidden onChange={handleChequeSelect} />
          </label>
        )}
      </div>
    </div>
  ) : (
    <label className="rp-personalinfo-upload-card">
      <div className="rp-personalinfo-plus">+</div>
      <span>Upload Cheque</span>
      <input type="file" hidden disabled={!isEdit} onChange={handleChequeSelect} />
    </label>
  )}
</div>)}

        {isEdit && (
          <div className="rp-personalinfo-actions">
            <button
              onClick={handleUpdate}
              className="rp-personalinfo-save-btn"
              disabled={isSaving}
            >
              {isSaving ? "Saving..." : "Save Changes"}
            </button>
          </div>
        )}
      </div>
      {previewImage && (
  <div className="rp-image-preview-overlay">
    <div className="rp-image-preview-modal">
      <button
        className="rp-image-preview-close"
        onClick={() => setPreviewImage(null)}
      >
        ✕
      </button>
      <img src={previewImage} alt="Preview" />
    </div>
  </div>
)}
    </div>
  );
};

export default BankDetails;
